export enum StatBarType {
  None = 0,
  Float = 0b10
}
